import { createSlice } from "@reduxjs/toolkit";

// Estado inicial del slice
const initialState = {
    Tareas: [],
};

// Definición del slice
export const registroTareasSlice = createSlice({
    name: "Tareas",
    initialState,
    reducers: {
        // Agrega una nueva tarea al estado
        agregarTarea: (state, action) => {
            state.Tareas.push(action.payload); // Añade directamente al array
        },

        // Elimina una tarea del estado usando el id
        borrarTarea: (state, action) => {
            // Filtra las tareas que no coinciden con el id proporcionado
            state.Tareas = state.Tareas.filter(tarea => tarea.id !== action.payload.id);
        }
    }
});

// Exporta las acciones generadas por el slice
export const { agregarTarea, borrarTarea } = registroTareasSlice.actions;

// Exporta el reductor para usarlo en el store
export default registroTareasSlice.reducer;
